import React, {Component} from "react";
import "./partnerStories.css";
import CKEditor from "react-ckeditor-component";
import axios from "axios";
import {host} from "../../../utils/globals";
import {scrollTop} from "../../../utils/helpers";
import PartnerStoryPartial from "../../partnerStory/PartnerStoryPartial";
import {NavLink} from "react-router-dom";
import $ from "jquery";

export default class PartnerForm extends Component {

    state = {
        details: "",
        title: "",
        image: "",
        submitted_by: "",
        url: "",
        email: "",
        validEmail: false,
    };

    updateContent = newContent => {
        this.setState({
            details: newContent
        });
    };

    onChange = e => {
        let {name, value} = e.target;
        this.setState({
            [name]: value
        });
    };

    validateEmail = email => {
        const re = /^\S+@\S+$/;
        return re.test(email);
     };
 
     onEmailChange = e => {
         let {name, value} = e.target;
         this.setState({
             [name]: value,
             'validEmail': this.validateEmail(value)
         });
     };

    onImageChange = evt => {
        let target = evt.target;
        let name = target.name;
        let file = target.files[0];

        let reader = new FileReader();
        reader.readAsDataURL(file);
        let self = this;
        reader.onloadend = function (e) {
            self.setState({
                [name]: [reader.result]
            });
        };
    };

    onCKeditorChange = evt => {
        let newContent = evt.editor.getData();
        this.setState({
            details: newContent
        });
    };

    submitHandler = e => {
        e.preventDefault();
        let self = this;
        let form = document.getElementById("partnerFormInput");
        const formData = new FormData(form);
        formData.append("details", this.state.details);
        axios
            .post(`${host}/api/partner_story/add`, formData)
            .then(function (response) {
                self.setState({
                    details: "",
                    title: "",
                    image: "",
                    source: "",
                    url: ""
                });
                alert(response.data.message);
                $("#previewModal")
                    .find("button#hideModal")
                    .trigger("click");
                  self.setState({
			details: "",
			title: "",
			image: "",
			submitted_by: "",
			url: "",
			email: "",
			validEmail: false,
		    });
            })
            .catch(err => console.log(err));
    };

    componentDidMount() {
        scrollTop();
    }

    render() {
        const {title, details, email,validEmail} = this.state;
        return (
            <section id="partnerForm">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="hrrp-form">
                                <NavLink to="/" className="btn btn-danger cross-btn">
                                    <i className="fa fa-times"/>
                                </NavLink>
                                <div className="row">
                                    <div className="hidden-xs col-sm-3">
                                        <div className="form-banner">
                                            <img
                                                src="/img/4.png"
                                                alt="partner stories"
                                                className="img-responsive"
                                            />
                                            <div className="overlay-text text-center">
                                                <span className="partner">Partner</span> <br/>
                                                stories
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-9">
                                        <form
                                            className="form-horizontal"
                                            encType="multipart/form-data"
                                            id="partnerFormInput"
                                            onSubmit={e => e.preventDefault()}
                                        >
                                            <div>
                                                <h4>
                                                    ‘Partner stories’ is an initiative by HRRP to collect relevant
                                                    reconstruction and
                                                    recovery stories from Partner Organizations as well as all concerned
                                                    stakeholders.
                                                    These stories when submitted will be reviewed by HRRP and the
                                                    published on the HRRP website.
                                                    Partner’s will be contacted if further details are required.
                                                </h4>
                                            </div>
                                            <br/>
                                            <div className="form-group">
                                                <label
                                                    htmlFor="titleText"
                                                    className="col-sm-3 control-label"
                                                >
                                                    Title <sup className="text-danger">*</sup>
                                                </label>
                                                <div className="col-sm-8">
                                                    <input
                                                        onChange={this.onChange}
                                                        name="title"
                                                        type="text"
                                                        className="form-control"
                                                        id="titleText"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label
                                                    htmlFor="partnerImg"
                                                    className="col-sm-3 control-label"
                                                >
                                                    Image (optional)
                                                    <p>Cover photo of the story</p>
                                                </label>
                                                <div className="col-sm-8">
                                                    <input
                                                        onChange={this.onImageChange}
                                                        type="file"
                                                        className="form-control"
                                                        name="image"
                                                        id="partnerImg"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label
                                                    htmlFor="detail"
                                                    className="col-sm-3 control-label"
                                                >
                                                    Detail <sup className="text-danger">*</sup>
                                                    <p>Include the story here. Format as required.</p>
                                                </label>
                                                <div className="col-sm-8">
                                                    <CKEditor
                                                        activeClass="p10"
                                                        name="details"
                                                        id="detail"
                                                        content={this.state.details}
                                                        events={{
                                                            change: this.onCKeditorChange
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label
                                                    htmlFor="sourceText"
                                                    className="col-sm-3 control-label"
                                                >
                                                    Submitted by
                                                    <p>Partner Organization / Individual</p>
                                                </label>
                                                <div className="col-sm-8">
                                                    <input
                                                        onChange={this.onChange}
                                                        name="submitted_by"
                                                        type="text"
                                                        className="form-control"
                                                        id="submitted_by"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="url" className="col-sm-3 control-label">
                                                    Url (optional)
                                                    <p>Website address</p>
                                                </label>
                                                <div className="col-sm-8">
                                                    <input
                                                        onChange={this.onChange}
                                                        name="url"
                                                        type="url"
                                                        className="form-control"
                                                        id="url"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="email" className="col-sm-3 control-label">
                                                    Email <sup className="text-danger">*</sup>
                                                    <p>Email address of correspondence</p>
                                                </label>
                                                <div className="col-sm-8">
                                                    <input
                                                        onChange={this.onEmailChange}
                                                        name="email"
                                                        type="text"
                                                        className="form-control"
                                                        id="email"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="col-sm-offset-2 col-sm-10 ">
                                                    <button
                                                        type="button"
                                                        data-toggle="modal"
                                                        data-target="#previewModal"
                                                        className="btn btn-danger  pull-right"
                                                    >
                                                        Preview
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                        <div id="previewModal" className="modal fade" role="dialog">
                                            <div className="modal-dialog modal-lg">
                                                <div className="modal-content">
                                                    <div className="modal-body">
                                                        <PartnerStoryPartial
                                                            isEnglish={true}
                                                            data={this.state}
                                                            isPreview={true}
                                                        />
                                                    </div>

                                                    <div className="clearfix"/>
                                                    <div className="modal-footer">
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            data-dismiss="modal"
                                                            id="hideModal"
                                                        >
                                                            Cancel
                                                        </button>
                                                        {!title || !details || !email ? 
                                                        <p className="float-rigth text-info" style={{marginTop:'10px'}}>Please fill all required fields.</p> 
                                                        : (!validEmail ? <p className="float-rigth text-info" style={{marginTop:'10px'}}>Please provide valid email.</p>
                                                        : <button
                                                                type="button"
                                                                className="btn btn-primary text-uppercase"
                                                                onClick={this.submitHandler}
                                                            >
                                                                Submit
                                                            </button>)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
